export default __webpack_public_path__ + "static/media/envelope.7370c16d.svg";